export default {
    voltar: 'Go Back',
    listagem: 'Listing',
    integracoes: {
        atributos: 'Attributes',
        credenciais: 'Credentials',
        cloud_functions: 'CloudFunctions',
        configuracao_protocolo: 'Protocol Configuration',
        estados: 'States',
        fabricante: 'Manufacturer',
        formatos_arquivos: 'File Formats',
        integration_helper: 'Classes Helpers',
        label: 'Integrations',
        protocolos: 'Protocols',
        resultados_descartaveis: 'Trash Report',
        resultados_controle_descartaveis: 'Recipient Control',
        resultados_editaveis: 'Editable Results',
    },
    triggers: 'Triggers',
    dexpara:{
        label: 'Mapping',
        ordem: 'Order Examinations',
        resultado: 'Results Exams',
        materiais: 'Materials',
        complements: 'Complements',
        metodos: 'Methods',
        exame_resultado: 'Result Value',
        tipo: 'By Type',
        tipo_create: 'Register Type',
        result_range_create: 'Result Range',
        result_conversion_create: 'Result Conversion'
    },
    equipamentos: {
        label: 'Equipments',
        ranges: 'Ranges',
        criar_range: 'Create Range',
        permissoes: 'Permissions'
    },
    monitores: {
        label: 'Monitors',
        tipo: 'VNS by Type',
        fila_atendimento: 'Service Queue',
        lista: 'Monitor List',
        ordem_resultado: 'Order / Result',
        ordem_resultado_apoio: 'Order / Result - Support',
        ordem_resultado_lis: 'Order / Result - Lis',
        etiquetas_apoio: 'Tags Support',
        revisar_resultado: 'Review Observation'
    },
    tuevs: {
        label: 'TUEVS',
        dashboard: 'Dashboard',
        importar_exames_clientes_cadastrados: 'Import Client Exams',
        componentes: 'Components',
        exames: 'Exams',
        materiais: 'Materials',
        complements: 'Complements',
        metodos: 'Methods',
        escalas: 'Scales',
        tempos: 'Times',
        examresult: 'Result Value',
    },
    loinc: {
        label: 'LOINC',
        listagem: 'Listing',
        importar_csv: 'Import CSV',
        importar_traducoes: 'Import CSV From Translations'
    },
    rnds: {
        listar: 'List Broadcasts',
        transmitir: 'Transmit Results'
    },
    interopera: {
        transmitir: 'Transmit Results'
    },
    core: {
        label: "Veus Saúde",
        companies: 'Companies',
        careunits: 'Units',
        sector: 'Sector'
    },
    language: {
        select: 'Select the Language'
    },
    auditoria: {
        label: 'Audit',
        logs: 'Logs'
    }
}
